<div class="pin-code-container fs-5" (click)="focusInput()">
    <div class="pin-display-box">
        <div class="pin-content">
            <span *ngFor="let char of displayCharacters; let i = index" class="pin-position">
                <span *ngIf="i < value.length" class="pin-digit">
                    {{ showPin ? char : '•' }}
                </span>
                <span *ngIf="i === value.length && focused" class="pin-cursor">|</span>
                <span *ngIf="i >= value.length" class="pin-underscore">_</span>
            </span>
        </div>
        
        <button
            type="button"
            class="btn btn-sm btn-outline-secondary pin-toggle"
            (click)="toggleShowPin(); $event.stopPropagation()"
            [disabled]="disabled"
        >
            <i class="bi" [class.bi-eye]="!showPin" [class.bi-eye-slash]="showPin"></i>
        </button>
    </div>
    
    <input
        class="pin-hidden-input visually-hidden"
        [value]="value"
        [disabled]="disabled"
        [placeholder]="placeholder"
        type="number"
        inputmode="numeric"
        pattern="[0-9]*"
        [maxLength]="maxLength"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        autocomplete="off"
        #hiddenInput
    >
</div>
